/**
 * @generated SignedSource<<81250347205da3fb2dc893e327bada25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarouselRefetch_viewer$data = {
  readonly photos?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_photos">;
  } | null> | null;
  readonly " $fragmentType": "ProductImageCarouselRefetch_viewer";
};
export type ProductImageCarouselRefetch_viewer$key = {
  readonly " $data"?: ProductImageCarouselRefetch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarouselRefetch_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchPhotos"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ProductImageCarouselRefetchQuery.graphql')
    }
  },
  "name": "ProductImageCarouselRefetch_viewer",
  "selections": [
    {
      "condition": "fetchPhotos",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "ItemPhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductCarouselItem_photos"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "da41128a7beb292e1c821e705541b6e5";

export default node;
